// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// const Minicart = ({ isOpen, onClose, setCartItemCount }) => {
//   // Accept setCartItemCount as a prop
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch cart details on component mount
//   useEffect(() => {
//     const fetchCartDetails = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const userId = localStorage.getItem("userId");
//         if (userId) {
//           const response = await axios.get(
//             `https://vishushethra.com/api/api/cart-fetch/${userId}/`
//           );
//           const cartData = response.data.cart;
//           setCartItems(cartData);
//           setCartItemCount(cartData.length); // Pass the count to parent component
//         } else {
//           setError("User ID not found in local storage.");
//         }
//       } catch (err) {
//         console.error(err);
//         setError("Failed to fetch cart details.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCartDetails();
//   }, [setCartItemCount]);

//   // Handle remove item from cart
//   const handleRemoveItem = async (cartItemId) => {
//     try {
//       await axios.delete(
//         `https://vishushethra.com/api/api/cart-remove/${cartItemId}/`
//       );
//       setCartItems((prevItems) => {
//         const updatedItems = prevItems.filter(
//           (item) => item.cart_item_id !== cartItemId
//         );
//         setCartItemCount(updatedItems.length); // Update cart item count after removal
//         return updatedItems;
//       });
//       Swal.fire({
//         icon: "success",
//         title: "Removed",
//         text: "Item removed successfully from cart!",
//         timer: 1500,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       console.error("Error removing item from cart", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to remove item from cart.",
//       });
//     }
//   };

//   return (
//     <div className={`minicart-header ${isOpen ? "show" : ""}`}>
//       <div className="minicart-headermain">
//         <div className="minicart-headermaintext d-flex flex-row align-items-center">
//           <h4>
//             Cart{" "}
//             {cartItems.length > 0 && (
//               <span style={{ fontSize: "14px", color: "gray" }}>
//                 ({cartItems.length} {cartItems.length > 1 ? "items" : "item"})
//               </span>
//             )}
//           </h4>
//           <div className="">
//             <Link className="" to="/Cart" onClick={onClose}>
//               View cart
//             </Link>
//           </div>
//         </div>
//         <div
//           onClick={onClose}
//           style={{ cursor: "pointer" }}
//           className="minicart-headermainclose"
//         >
//           <i className="ion-android-close"></i>
//         </div>
//       </div>
//       <hr />

//       <div className="minicart-content">
//         <div className="minicart-main row">
//           {loading ? (
//             <p>Loading...</p>
//           ) : error ? (
//             <p>{error}</p>
//           ) : cartItems.length > 0 ? (
//             cartItems
//               .slice()
//               .reverse()
//               .map((item) => (
//                 <div
//                   className="minicart-inner d-flex justify-content-between"
//                   key={item.cart_item_id}
//                 >
//                   <div>
//                     <img src={item.images[0]} alt={item.product_name} />
//                   </div>
//                   <div>
//                     <p>{item.product_name}</p>
//                     <p>
//                       Price: ₹{item.total_price}{" "}
//                       <span style={{ fontSize: "13px" }}>INR</span>
//                     </p>
//                     <p>Quantity: {item.quantity}</p>
//                   </div>
//                   <div>
//                     <button
//                       className="btn btn-danger"
//                       onClick={() => handleRemoveItem(item.cart_item_id)}
//                     >
//                       <i className="ion-android-close"></i>
//                     </button>
//                   </div>
//                 </div>
//               ))
//           ) : (
//             <p>Your cart is empty.</p>
//           )}
//         </div>
//         <hr />
//         <div className="place_order_btn">
//           <Link
//             className="btn btn-primary"
//             to="/Cart"
//             onClick={() => {
//               onClose();
//               window.location.href = "/Cart"; // Forces a full reload
//             }}
//           >
//             View cart
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Minicart;

// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { GoTrash } from "react-icons/go";

// const Minicart = ({ isOpen, onClose, setCartItemCount }) => {
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch cart details on component mount and when isOpen changes
//   useEffect(() => {
//     const fetchCartDetails = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const userId = localStorage.getItem("userId");
//         let url = "https://vishushethra.com/api/api/cart-fetch/";
//         let config = {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           withCredentials: false,
//         };

//         if (userId) {
//           url = `https://vishushethra.com/api/api/cart-fetch/${userId}/`;
//         }

//         const response = await axios.get(url, config);

//         if (response.data && response.data.cart) {
//           const cartData = response.data.cart || [];
//           console.log("miniCart Items:", cartData);
//           setCartItems(cartData);
//           setCartItemCount(cartData.length);
//         } else {
//           setCartItems([]);
//           setError("No cart items found.");
//         }
//       } catch (err) {
//         console.error("Error fetching cart:", err);
//         setError("Failed to fetch cart details. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (isOpen) {
//       fetchCartDetails();
//     }
//   }, [isOpen, setCartItemCount]);

//   // Handle remove item from cart
//   const handleRemoveItem = async (cartItemId) => {
//     try {
//       await axios.delete(
//         `https://vishushethra.com/api/api/cart-remove/${cartItemId}/`
//       );

//       // Optimistic update
//       setCartItems((prevItems) => {
//         const updatedItems = prevItems.filter(
//           (item) => item.cart_item_id !== cartItemId
//         );
//         setCartItemCount(updatedItems.length);
//         return updatedItems;
//       });

//       Swal.fire({
//         icon: "success",
//         title: "Removed",
//         text: "Item removed successfully from cart!",
//         timer: 1500,
//         showConfirmButton: false,
//       });
//     } catch (error) {
//       console.error("Error removing item from cart", error);
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Failed to remove item from cart.",
//       });
//     }
//   };

//   return (
//     <div className={`minicart-header ${isOpen ? "show" : ""}`}>
//       <div className="minicart-headermain">
//         <div className="minicart-headermaintext d-flex flex-row align-items-center">
//           <h4>
//             Cart{" "}
//             {cartItems.length > 0 && (
//               <span style={{ fontSize: "14px", color: "gray" }}>
//                 ({cartItems.length} {cartItems.length > 1 ? "items" : "item"})
//               </span>
//             )}
//           </h4>
//           <div>
//             <Link to="/Cart" onClick={onClose}>
//               View cart
//             </Link>
//           </div>
//         </div>
//         <div
//           onClick={onClose}
//           style={{ cursor: "pointer" }}
//           className="minicart-headermainclose"
//         >
//           <i className="ion-android-close"></i>
//         </div>
//       </div>
//       <hr />

//       <div className="minicart-content">
//         <div className="minicart-main row">
//           {loading ? (
//             <div className="text-center w-100 py-3">
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           ) : error ? (
//             <p className="text-danger text-center">{error}</p>
//           ) : cartItems.length > 0 ? (
//             [...cartItems].reverse().map((item) => (
//               <div
//                 className="minicart-inner d-flex justify-content-between align-items-center mb-3"
//                 key={item.cart_item_id}
//               >
//                 <div className="minicart-image">
//                   <Link
//                     to={`/Productdetail/${item.product_id}`}
//                     onClick={onClose}
//                   >
//                     <img
//                       src={item.images[0]}
//                       alt={item.product_name}
//                       className="img-fluid"
//                       style={{
//                         width: "60px",
//                         height: "60px",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Link>
//                 </div>
//                 <div
//                   className="minicart-details"
//                   style={{ flex: 1, padding: "0 10px" }}
//                 >
//                   <p style={{ marginBottom: "5px", fontWeight: "500" }}>
//                     <Link
//                       to={`/Productdetail/${item.product_id}`}
//                       onClick={onClose}
//                       style={{ color: "inherit", textDecoration: "none" }}
//                     >
//                       {item.product_name}
//                     </Link>
//                   </p>
//                   <p style={{ marginBottom: "5px", fontSize: "14px" }}>
//                     Price: ₹
//                     {parseFloat(item.item_price).toLocaleString("en-IN", {
//                       minimumFractionDigits: 2,
//                     })}{" "}
//                     <span style={{ fontSize: "12px" }}>INR</span>
//                   </p>
//                   <p style={{ marginBottom: "0", fontSize: "14px" }}>
//                     Qty: {item.quantity}
//                   </p>
//                   {item.sold_out && (
//                     <span className="badge bg-danger mt-1">Sold Out</span>
//                   )}
//                 </div>
//                 <div className="minicart-remove">
//                   <button
//                     className="btn btn-outline-danger btn-sm"
//                     onClick={() => handleRemoveItem(item.cart_item_id)}
//                     style={{ padding: "5px" }}
//                     disabled={loading}
//                   >
//                     <GoTrash />
//                   </button>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="text-center w-100 py-3">
//               <p>Your cart is empty.</p>
//               <Link
//                 to="/Shop"
//                 className="btn btn-primary btn-sm"
//                 onClick={onClose}
//               >
//                 Continue Shopping
//               </Link>
//             </div>
//           )}
//         </div>
//         <hr />
//         {cartItems.length > 0 && (
//           <div className="place_order_btn">
//             <Link
//               className="btn btn-primary w-100"
//               to="/Payment"
//               onClick={onClose}
//               style={{ textAlign: "center" }}
//             >
//               Proceed to Checkout
//             </Link>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Minicart;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { GoTrash } from "react-icons/go";

const Minicart = ({ isOpen, onClose, setCartItemCount }) => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch cart details on component mount and when isOpen changes
  useEffect(() => {
    const fetchCartDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        const userId = localStorage.getItem("userId");
        let url = "https://vishushethra.com/api/api/cart-fetch/";
        let config = {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          withCredentials: false,
        };

        if (userId) {
          url = `https://vishushethra.com/api/api/cart-fetch/${userId}/`;
        }

        const response = await axios.get(url, config);
        console.log("Full API Response:", response); // Debug log

        // Handle different response structures
        let cartData = [];
        if (Array.isArray(response.data)) {
          // Case 1: Response is directly an array
          cartData = response.data;
        } else if (response.data && Array.isArray(response.data.cart)) {
          // Case 2: Response has cart property with array
          cartData = response.data.cart;
        } else if (response.data && Array.isArray(response.data.items)) {
          // Case 3: Response has items property with array
          cartData = response.data.items;
        } else {
          throw new Error("Unexpected response format from server");
        }

        console.log("Processed Cart Data:", cartData);

        if (cartData.length > 0) {
          // Ensure each item has required properties
          const validatedItems = cartData.map((item) => ({
            cart_item_id: item.cart_item_id || item.id,
            product_id: item.product_id || item.id,
            product_name: item.product_name || item.name,
            price: item.price || item.item_price || 0,
            quantity: item.quantity || 1,
            images: item.images
              ? Array.isArray(item.images)
                ? item.images.map((img) =>
                    typeof img === "string" ? img : img.image,
                  )
                : [item.images]
              : ["/placeholder-image.jpg"],
            sold_out: item.sold_out || false,
          }));

          setCartItems(validatedItems);
          setCartItemCount(validatedItems.length);
        } else {
          setCartItems([]);
          setCartItemCount(0);
        }
      } catch (err) {
        console.error("Error fetching cart:", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
          console.error("Response status:", err.response.status);
          setError(
            `Error ${err.response.status}: ${
              err.response.data.message || "Failed to fetch cart"
            }`,
          );
        } else if (err.message) {
          setError(err.message);
        } else {
          setError("Failed to connect to server. Please try again.");
        }
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchCartDetails();
    }
  }, [isOpen, setCartItemCount]);

  // Handle remove item from cart
  const handleRemoveItem = async (cartItemId) => {
    try {
      const response = await axios.delete(
        `https://vishushethra.com/api/api/cart-remove/${cartItemId}/`,
      );

      if (response.status === 200) {
        // Optimistic update
        setCartItems((prevItems) => {
          const updatedItems = prevItems.filter(
            (item) => item.cart_item_id !== cartItemId,
          );
          setCartItemCount(updatedItems.length);
          return updatedItems;
        });

        Swal.fire({
          icon: "success",
          title: "Removed",
          text: "Item removed successfully from cart!",
          timer: 1500,
          showConfirmButton: false,
        });
      } else {
        throw new Error("Failed to remove item");
      }
    } catch (error) {
      console.error("Error removing item from cart", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message || "Failed to remove item from cart.",
      });
    }
  };

  return (
    <div className={`minicart-header ${isOpen ? "show" : ""}`}>
      <div className="minicart-headermain">
        <div className="minicart-headermaintext d-flex flex-row align-items-center">
          <h4>
            Cart{" "}
            {cartItems.length > 0 && (
              <span style={{ fontSize: "14px", color: "gray" }}>
                ({cartItems.length} {cartItems.length > 1 ? "items" : "item"})
              </span>
            )}
          </h4>
          <div>
            <Link to="/Cart" onClick={onClose}>
              View cart
            </Link>
          </div>
        </div>
        <div
          onClick={onClose}
          style={{ cursor: "pointer" }}
          className="minicart-headermainclose"
        >
          <i className="ion-android-close"></i>
        </div>
      </div>
      <hr />

      <div className="minicart-content">
        <div className="minicart-main row">
          {loading ? (
            <div className="text-center w-100 py-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="text-center w-100 py-3">
              <p className="text-danger">{error}</p>
              <button
                className="btn btn-sm btn-outline-primary mt-2"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          ) : cartItems.length > 0 ? (
            cartItems.map((item) => (
              <div
                className="minicart-inner d-flex justify-content-between align-items-center mb-3"
                key={item.cart_item_id}
              >
                <div className="minicart-image">
                  <Link
                    to={`/Productdetail/${item.product_id}`}
                    onClick={onClose}
                  >
                    <img
                      src={item.images[0]}
                      alt={item.product_name}
                      className="img-fluid"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                      }}
                      onError={(e) => {
                        e.target.src = "/placeholder-image.jpg";
                      }}
                    />
                  </Link>
                </div>
                <div
                  className="minicart-details"
                  style={{ flex: 1, padding: "0 10px" }}
                >
                  <p style={{ marginBottom: "5px", fontWeight: "500" }}>
                    <Link
                      to={`/Productdetail/${item.product_id}`}
                      onClick={onClose}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {item.product_name}
                    </Link>
                  </p>
                  <p style={{ marginBottom: "5px", fontSize: "14px" }}>
                    Price: ₹
                    {parseFloat(item.price).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                    })}{" "}
                    <span style={{ fontSize: "12px" }}>INR</span>
                  </p>
                  <p style={{ marginBottom: "0", fontSize: "14px" }}>
                    Qty: {item.quantity}
                  </p>
                  {item.sold_out && (
                    <span className="badge bg-danger mt-1">Sold Out</span>
                  )}
                </div>
                <div className="minicart-remove">
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleRemoveItem(item.cart_item_id)}
                    style={{ padding: "5px" }}
                    disabled={loading}
                  >
                    <GoTrash />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center w-100 py-3">
              <p>Your cart is empty.</p>
              <Link
                to="/Shop"
                className="btn btn-primary btn-sm"
                onClick={onClose}
              >
                Continue Shopping
              </Link>
            </div>
          )}
        </div>
        <hr />
        {cartItems.length > 0 && (
          <div className="place_order_btn">
            <Link
              className="btn btn-primary w-100"
              to="/Payment"
              onClick={onClose}
              style={{ textAlign: "center" }}
            >
              Proceed to Checkout
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Minicart;
